import {submitHandler} from './submit-handler';

export function initRestore($, apiClient) {
    submitHandler('form.restore-form .action__restore', async function () {
        const params = {
            email: $('#email').val(),
        };
        await apiClient.restore(params);
        // Помечаем, что пришли с восстановления: текст на странице
        // должен быть осторожнее, чем после регистрации. Существует ли
        // такой адрес, мы не говорим — это выдавало бы, кто у нас
        // зарегистрирован.
        document.location.href='/complete?from=restore';
    });
}
